import React from "react";
import PropTypes from "prop-types";
const EnergyClass = ({isNewEnergyClass, energyClass}) => {
    let pictoClassNameList = {};
    if(isNewEnergyClass){
        pictoClassNameList = {'A': 'A', 'B': 'B', 'C': 'C', 'D': 'D', 'E': 'E', 'F': 'F', 'G': 'G'};
    } else {
        pictoClassNameList = {'A+++': 'A', 'A++': 'B', 'A+': 'C', 'A': 'D', 'B': 'E', 'C': 'F', 'D': 'G'};
    }
    let note = Object.entries(pictoClassNameList).find(([key, value]) =>  energyClass === key);
    note = note ? note : [energyClass, ''];
    return (
        <>
            {energyClass ?
                <div className={`picto-energie niv${note[1]}`}>
                    {isNewEnergyClass && <div className="icon" />}
                    <p id="gtm-energyClass-value" className="note">{note[0]}</p>
                </div> :
                null
            }
        </>
    )
}
export default EnergyClass;